import { ACTIVE_SERVER_ID } from 'mk/settings';
import { PageMode } from 'mk2/apps/strollers/containers/StrollersSearch/StrollersSearch.constants';

const prefixes = {
    201: 'kocikopedia',
    202: 'kocarkopedie',
    207: 'strollers',
};

const prefix = prefixes[ACTIVE_SERVER_ID];

export const strollers = `/${prefix}/`;

export const strollersSearch = `/${prefix}/search/:pageMode(${Object.keys(PageMode).map((k) => PageMode[k]).join('|')})/`;

export const strollersWishlist = `/${prefix}/wishlist/`;

export const strollersList = `/${prefix}/brand/:slug([-\\w]+)/`;

export const strollersAddReview = `/${prefix}/:slug([-\\w]+)/add_review/`;
export const strollersAddReviewScore = `/${prefix}/:slug([-\\w]+)/add_review/:screen(score)/`;
export const strollersReview = `/${prefix}/:slug([-\\w]+)/review/:reviewId(\\d+)/`;
export const strollersReviews = `/${prefix}/:slug([-\\w]+)/reviews/`;

export const strollersAddQuestion = `/${prefix}/:slug([-\\w]+)/add_question/`;

export const strollersDetail = `/${prefix}/:slug([-\\w]+)/`;
export const strollersDetailAlternate = (server) => `/${prefixes[server]}/:slug([-\\w]+)/`;
